import { ReactNode, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { BottomTabBar } from './BottomTabBar';
import { HelpSlideout } from '../help/HelpSlideout';
import { BroadcastBanner } from '../BroadcastBanner';

interface MobileLayoutProps {
  children: ReactNode;
  showBottomNav?: boolean;
}

export function MobileLayout({ children, showBottomNav = true }: MobileLayoutProps) {
  const [showHelp, setShowHelp] = useState(false);
  const location = useLocation();

  // Auto-close help slideout on route changes
  useEffect(() => {
    setShowHelp(false);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-gray-300">
      {/* Fixed background column - always covers full viewport height */}
      <div className="fixed inset-0 max-w-md mx-auto bg-white shadow-xl pointer-events-none" />

      {/* Content layer - normal document flow, above the fixed background */}
      <div className="relative max-w-md mx-auto min-h-screen flex flex-col">
        {/* Broadcast Banners */}
        <BroadcastBanner />

        {/* Main Content Area with bottom padding for tab bar */}
        <main className={`flex-1 ${showBottomNav ? 'pb-16' : ''}`}>{children}</main>

        {/* Bottom Navigation */}
        {showBottomNav && (
          <BottomTabBar onInfoClick={() => setShowHelp((prev) => !prev)} isInfoActive={showHelp} />
        )}
      </div>

      {/* Help Slideout */}
      {showBottomNav && <HelpSlideout isOpen={showHelp} onClose={() => setShowHelp(false)} />}
    </div>
  );
}
